export const USER_KEY = 'user';

export const TOKEN_KEY = 'token';